import { render, staticRenderFns } from "./Complements.vue?vue&type=template&id=96c621ba"
import script from "./Complements.vue?vue&type=script&lang=ts"
export * from "./Complements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports